import React from "react";
import {
  FaUserShield,
  FaCogs,
  FaProjectDiagram,
  FaFileContract,
  FaLayerGroup,
  FaLandmark,
  FaLock,
  FaCoins,
  FaDesktop,
} from "react-icons/fa";

function NonCustodial() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-35 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Features & Functionalities of our Decentralized Exchange
                        Development
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaUserShield size={45} />
                      </div>
                      <h4>Non-Custodial Trading</h4>
                      <p>
                        Xeer Technology’s DEX ensures users retain full control
                        of their assets. Trades are executed directly from
                        users' wallets without the need for a third-party to
                        hold funds, enhancing security and privacy.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCogs size={45} />
                      </div>
                      <h4>Automated Market Making (AMM)</h4>
                      <p>
                        The DEX employs AMM protocols, enabling liquidity pools
                        where users can provide liquidity in exchange for
                        rewards. This ensures efficient trading without relying
                        on traditional order books.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaProjectDiagram size={45} />
                      </div>
                      <h4>Cross-Chain Asset Trading</h4>
                      <p>
                        Xeer Technology integrates cross-chain functionality,
                        allowing users to trade assets across multiple
                        blockchain networks, such as Ethereum, Binance Smart
                        Chain (BSC), and others, using secure bridges.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaFileContract size={45} />
                      </div>
                      <h4>Smart Contract-Based Transactions</h4>
                      <p>
                        All trades are executed through smart contracts,
                        ensuring transparent and automated transaction
                        processing without intermediaries, providing greater
                        trust and security for users.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLayerGroup size={45} />
                      </div>
                      <h4>Liquidity Pools and Yield Farming</h4>
                      <p>
                        The DEX offers liquidity pools where users can stake
                        their assets to earn rewards. Additionally, yield
                        farming opportunities are available, allowing users to
                        generate passive income by providing liquidity to the
                        platform.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLandmark size={45} />
                      </div>
                      <h4>Governance and Voting Mechanism</h4>
                      <p>
                        Xeer Technology integrates decentralized governance
                        features, enabling users to participate in
                        decision-making processes, such as protocol upgrades,
                        fee structures, or new feature rollouts, by staking
                        governance tokens.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLock size={45} />
                      </div>
                      <h4>Advanced Security Features</h4>
                      <p>
                        The platform is built with a focus on security,
                        incorporating features such as multi-signature wallets,
                        end-to-end encryption, and on-chain audits to ensure the
                        integrity of the platform and user funds.
                      </p>
                    </div>{" "}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={45} />
                      </div>
                      <h4>Low Transaction Fees and High Scalability</h4>
                      <p>
                        Xeer Technology’s DEX ensures minimal transaction fees
                        by optimizing smart contracts and employing scalable
                        solutions like layer-2 technology, which allows for
                        faster transactions at lower costs.
                      </p>
                    </div>{" "}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaDesktop size={45} />
                      </div>
                      <h4>
                        User-Friendly Interface and Customizable Dashboards
                      </h4>
                      <p>
                        The DEX offers an intuitive user interface with
                        customizable dashboards, allowing traders of all
                        experience levels to access essential tools, real-time
                        data, and personalized trading experiences effortlessly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NonCustodial;
